module.exports = {
	customize: '',
	nodes: {
		zz10060: false,
	},
};